import { getRequest } from "@components/config/axiosClient";
import useSWR from "swr";

const fetcher = (url) => getRequest(url).then((res) => res.data);

const useAPI = (uri, SWRProps = {}) => {
    const generateUri = () => {
        return uri;
    };

    const generateQuery = () => {
        const uri = generateUri();
        return fetcher(uri).then((data) => {
            return data;
        });
    };

    const { data, error, isLoading } = useSWR(generateUri(), generateQuery, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        revalidate: false,
        ...SWRProps
    });

    return { data, error, isLoading };
};

export default useAPI;
